// extracted by mini-css-extract-plugin
module.exports = {"root":"m_bJ"};